const rollbarConfig = {
  enabled: !import.meta.env.DEV,
  accessToken: import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: import.meta.env.MODE,
  payload: {},
};

export default rollbarConfig;
